export default "__VITE_ASSET__BViJfEXq__"